import { createFileRoute, redirect } from "@tanstack/react-router";
import { DEFAULT_COMPANY } from "../prototype/fixtures";

export const Route = createFileRoute("/prototype/")({
  beforeLoad: () => {
    throw redirect({ to: "/prototype/c/$companyId/home", params: { companyId: DEFAULT_COMPANY } });
  },
});
